<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>{{acronym}}: {{title}}</h4>
    <button mat-button [mat-dialog-close]="" cdkFocusInitial>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-tree
    mat-dialog-content
    class="dialog-content"
    [dataSource]="dataSource"
    [treeControl]="treeControl"
  >
    <mat-tree-node
      *matTreeNodeDef="let node"
      matTreeNodePadding
      class="node-column"
    >
      <span [innerHTML]="renderLeafNode(node)"></span>
    </mat-tree-node>

    <mat-tree-node
      *matTreeNodeDef="let node; when: hasChild"
      matTreeNodePadding
      class="spinner-container"
    >
      @if (!node.item.startsWith('SD')) {
      <button
        mat-icon-button
        [attr.aria-label]="'click to toggle'"
        matTreeNodeToggle
      >
        <mat-icon class="mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
        </mat-icon>
      </button>
      }
      <span
        [class]="isHighlighted(node) ? 'selected' : ''"
        [innerHTML]="node.item"
      ></span>
      @if (node.isLoading) {
      <mat-spinner
        mode="indeterminate"
        class="example-tree-progress-bar"
      ></mat-spinner>
      }
    </mat-tree-node>
  </mat-tree>
</div>
